import { render, staticRenderFns } from "./ConsultaComprobantesMov.vue?vue&type=template&id=e92e8de2&"
import script from "./ConsultaComprobantesMov.vue?vue&type=script&lang=js&"
export * from "./ConsultaComprobantesMov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports